import {
  Button,
  Center,
  useMantineTheme,
  Flex,
  Text,
  Tooltip,
} from "@mantine/core";
import { AddCircle, InfoCircle, TickCircle } from "iconsax-react";
import { useFieldArray, useFormContext } from "react-hook-form";
import { TextInputControlled } from "../../../../../components";
import { IFormUser } from "../../../../../interfaces/User/newUser";
import { useTranslation } from "react-i18next";

export function EmailsBrokers() {
  const { t } = useTranslation();
  const theme = useMantineTheme();
  const { control } = useFormContext<IFormUser>();
  const {
    fields: fieldsArray,
    append,
    remove,
  } = useFieldArray({
    control,
    name: "secondary_emails",
    keyName: "key",
  });

  const fields = fieldsArray.map((field, index) => (
    <Flex key={`${field.key}-${index}`} gap={24} w={"100%"} align={"end"}>
      <Flex direction={"column"} w={"100%"}>
        <TextInputControlled
          name={`secondary_emails.${index}.email`}
          label="E-mail"
          placeholder={t("global.input.email.placeholder_generic")}
          withAsterisk
          width={"100%"}
        />
      </Flex>

      <Flex direction={"column"}>
        <Text
          style={{ fontSize: "14px", fontWeight: 600, marginBottom: "4px" }}
        >
          {t("meu_perfil.configuracoes.modal_edit.status")}
        </Text>
        <Center
          bg={field.is_active ? "alertsOpacity.2" : "alertsOpacity.1"}
          h={60}
          miw={"60px"}
          style={{ borderRadius: "12px" }}
        >
          {field.is_active ? (
            <TickCircle
              size="32"
              color={theme.colors.complementary[0]}
              variant="Bold"
            />
          ) : (
            <InfoCircle
              size="32"
              color={theme.colors.alerts[1]}
              variant="Bold"
            />
          )}
        </Center>
      </Flex>

      <Button variant="outline" color="red" onClick={() => remove(index)}>
        {t("global.button.remove")}
      </Button>
    </Flex>
  ));

  return (
    <Flex w={"100%"} direction={"column"} gap={24}>
      <Flex gap="12px" align="center">
        <Text fw={600} size={24} color={theme.colors.basic[5]}>
          {t("meu_perfil.configuracoes.modal_edit.brokers")}
        </Text>
        <Tooltip
          withArrow
          label={t("meu_perfil.configuracoes.modal_edit.tooltip_brokers")}
          multiline
          width={220}
          position="top-start"
        >
          <InfoCircle size="24" color={theme.colors.basic[4]} variant="Bold" />
        </Tooltip>
      </Flex>
      <Flex direction={"column"} gap={20}>
        {fields}
      </Flex>

      <Button
        variant="primary"
        maw="220px"
        onClick={() =>
          append({
            email: "",
            is_active: false,
            created_at: new Date(),
            updated_at: new Date(),
            user_id: 0,
            user: "",
            id: 0,
          })
        }
        leftIcon={<AddCircle size="24" color="#FFFFFF" />}
      >
        {t("meu_perfil.configuracoes.modal_edit.button_add_email")}
      </Button>
    </Flex>
  );
}
